// AI Video Production add-on - single quantity-based product.
// Source-of-truth for display prices. Backend `/api/stripe/ai-video-links`
// returns the same numbers (and the live Stripe price IDs).

export const AI_VIDEO_PRICING = {
  gbp: 380,
  eur: 440,
  usd: 480,
};

export const AI_VIDEO_CURRENCY_SYMBOL = {
  gbp: '£',
  eur: '€',
  usd: '$',
};

export const AI_VIDEO_FEATURES = [
  '40-60 sec high-quality AI video',
  'Scriptwriting (hook + narrative + CTA)',
  'Premium visuals (not basic templates)',
  'AI voiceover (natural, brand-aligned)',
  'Subtitles + formatting',
  'Multi-platform ready',
];

export const AI_VIDEO_MIN_QTY = 1;
export const AI_VIDEO_MAX_QTY = 50;
